import { type FC, Suspense, useEffect, useState, lazy } from 'react';

import { type GetHelpModalProps } from '../src/types.ts';
import { getGetHelpZendeskLocalStorageState } from '../src/getHelpZendesk/getHelpZendeskHelpers.ts';
import { isGetHelpModalZendeskVariant } from '../src/helpers.tsx';

const GetHelpModal = lazy(
    () => import(/* webpackChunkName: "GetHelpModal" */ '../src/GetHelp.tsx')
);

const GetHelpModalLazy: FC<GetHelpModalProps & { isPersistedModal?: boolean }> = ({
    isOpen,
    onClose,
    isPersistedModal,
    ...props
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const isModalAlreadyOpen = isGetHelpModalZendeskVariant()
            ? !!getGetHelpZendeskLocalStorageState()?.isOpen
            : false;

        if (isOpen && (!isModalAlreadyOpen || isPersistedModal)) {
            setIsModalOpen(true);
        } else if (isOpen) {
            onClose();
        }
    }, [isOpen, onClose, isPersistedModal]);

    return isModalOpen ? (
        <Suspense fallback={null}>
            <GetHelpModal
                {...props}
                isOpen
                onClose={() => {
                    onClose();
                    setIsModalOpen(false);
                }}
            />
        </Suspense>
    ) : null;
};

export { GetHelpModalLazy };
